import React, {useState, useEffect} from 'react';
import {Switch, Redirect} from 'react-router-dom';
//DS
import {RouteWithLayout} from '../components';
import {Main as MainLayout, Minimal as MinimalLayout, LoginLayout} from '../layouts';

import {
   PruebaView,
   NotFoundView,
   SignInView,
   GenerarLicenciaView,
   ListarClienteView,
   ModificarLicenciaView,
   EnviarMailView,
   AdministrarLicenciasView,
   HistorialLicenciaView,
   ProductoView,
   VersionView,
   PresentacionView,
   ProductoDetalleView,
   CallbackView,
   RedirectLoginView,
   RegistrarSuscripcionNubeView,
   PatchNotesView,
   GestionTipoCambio,
   AdminClienteDsCloud,
   GestionarAppsDbs,
   BuscadorGuidView,
   DashboradView,
   AbonosPasarelaView,
   ReporteConciliadorView
} from '../views';
import DSLogin from '../views/miscelanea/DSLogin';
import * as SCRNS from './screens';
import ActualizacionMasivaLicencias from 'src/views/procesos/actualizacionMasivaLicencias/actualizacionMasivaLicencias';
import DSSignUp from 'src/views/miscelanea/DSSignUp';

const Routes = props => {
   const {logged} = props;
   const [esProduccion, setEsProduccion] = useState(false);
   useEffect(() => {
      setEsProduccion(
         !process.env.NODE_ENV !== 'production' && process.env.REACT_APP_DS_ENV === 'PROD'
      );
   }, []);
   const defaultPath = logged ? SCRNS.SCRN_DASHBOARD.path : SCRNS.SCRN_CALLBACK.path;
   return (
      <Switch>
         <Redirect exact from="/" to={defaultPath} />
         <RouteWithLayout
            component={PruebaView}
            exact
            layout={MainLayout}
            path={SCRNS.SCRN_PRUEBA.path}
            title={SCRNS.SCRN_PRUEBA.title}
            condition={logged && !esProduccion}
            conditionPathRedirect={defaultPath}
            queryOrigin
         />
         <RouteWithLayout
            component={PatchNotesView}
            exact
            layout={MinimalLayout}
            path={`${SCRNS.SCRN_PATCH_NOTES.path}/:producto`}
            title={SCRNS.SCRN_PATCH_NOTES.title}
            condition={!logged}
            conditionPathRedirect={defaultPath}
            queryOrigin
         />

         <RouteWithLayout
            component={GenerarLicenciaView}
            exact
            layout={MainLayout}
            path={SCRNS.SCRN_GENERAR_LICENCIA.path}
            title={SCRNS.SCRN_GENERAR_LICENCIA.title}
            condition={logged}
            conditionPathRedirect={defaultPath}
            queryOrigin
         />
         <RouteWithLayout
            component={RegistrarSuscripcionNubeView}
            exact
            layout={MainLayout}
            path={SCRNS.SCRN_SUSCRIPCION_NUBE.path}
            title={SCRNS.SCRN_SUSCRIPCION_NUBE.title}
            condition={logged}
            conditionPathRedirect={defaultPath}
            queryOrigin
         />
         <RouteWithLayout
            component={ModificarLicenciaView}
            exact
            layout={MainLayout}
            path={SCRNS.SCRN_MODIFICAR_LICENCIA.path}
            title={SCRNS.SCRN_MODIFICAR_LICENCIA.title}
            condition={logged}
            conditionPathRedirect={defaultPath}
            queryOrigin
         />
         <RouteWithLayout
            component={ActualizacionMasivaLicencias}
            exact
            layout={MainLayout}
            path={SCRNS.SCRN_ACTUALIZACION_MASIVA_LICENCIAS.path}
            title={SCRNS.SCRN_ACTUALIZACION_MASIVA_LICENCIAS.title}
            condition={logged}
            conditionPathRedirect={defaultPath}
            queryOrigin
         />
         <RouteWithLayout
            component={AdministrarLicenciasView}
            exact
            layout={MainLayout}
            path={SCRNS.SCRN_ADMINISTRAR_LICENCIA.path}
            title={SCRNS.SCRN_ADMINISTRAR_LICENCIA.title}
            condition={logged}
            conditionPathRedirect={defaultPath}
            queryOrigin
         />
         <RouteWithLayout
            component={ListarClienteView}
            exact
            layout={MainLayout}
            path={SCRNS.SCRN_LISTAR_LLAVES.path}
            title={SCRNS.SCRN_LISTAR_LLAVES.title}
            condition={logged}
            conditionPathRedirect={defaultPath}
            queryOrigin
         />
         <RouteWithLayout
            component={EnviarMailView}
            exact
            layout={MainLayout}
            path={SCRNS.SCRN_ENVIAR_MAIL.path}
            title={SCRNS.SCRN_ENVIAR_MAIL.title}
            condition={logged}
            conditionPathRedirect={defaultPath}
            queryOrigin
         />
         <RouteWithLayout
            component={HistorialLicenciaView}
            exact
            layout={MainLayout}
            path={SCRNS.SCRN_HISTORIAL_LICENCIA.path}
            title={SCRNS.SCRN_HISTORIAL_LICENCIA.title}
            condition={logged}
            conditionPathRedirect={defaultPath}
            queryOrigin
         />
         <RouteWithLayout
            component={ProductoView}
            exact
            layout={MainLayout}
            path={SCRNS.SCRN_PRODUCTO.path}
            title={SCRNS.SCRN_PRODUCTO.title}
            condition={logged}
            conditionPathRedirect={defaultPath}
            queryOrigin
         />
         <RouteWithLayout
            component={VersionView}
            exact
            layout={MainLayout}
            path={SCRNS.SCRN_VERSION.path}
            title={SCRNS.SCRN_VERSION.title}
            condition={logged}
            conditionPathRedirect={defaultPath}
            queryOrigin
         />
         <RouteWithLayout
            component={PresentacionView}
            exact
            layout={MainLayout}
            path={SCRNS.SCRN_PRESENTACION.path}
            title={SCRNS.SCRN_PRESENTACION.title}
            condition={logged}
            conditionPathRedirect={defaultPath}
            queryOrigin
         />
         <RouteWithLayout
            component={ProductoDetalleView}
            exact
            layout={MainLayout}
            path={SCRNS.SCRN_PRODUCTO_DETALLE.path}
            title={SCRNS.SCRN_PRODUCTO_DETALLE.title}
            condition={logged}
            conditionPathRedirect={defaultPath}
            queryOrigin
         />
         <RouteWithLayout
            component={GestionTipoCambio}
            exact
            layout={MainLayout}
            path={SCRNS.SCRN_GESTIONAR_TIPO_CAMBIO.path}
            title={SCRNS.SCRN_GESTIONAR_TIPO_CAMBIO.title}
            condition={logged}
            conditionPathRedirect={defaultPath}
            queryOrigin
         />
         <RouteWithLayout
            component={GestionarAppsDbs}
            exact
            layout={MainLayout}
            path={SCRNS.SCRN_GESTIONAR_APPS_DBS.path}
            title={SCRNS.SCRN_GESTIONAR_APPS_DBS.title}
            condition={logged}
            conditionPathRedirect={defaultPath}
            queryOrigin
         />
         <RouteWithLayout
            component={AdminClienteDsCloud}
            exact
            layout={MainLayout}
            path={SCRNS.SCRN_ADMINISTRAR_CLIENTES_DSCLOUD.path}
            title={SCRNS.SCRN_ADMINISTRAR_CLIENTES_DSCLOUD.title}
            condition={logged}
            conditionPathRedirect={defaultPath}
            queryOrigin
         />
         <RouteWithLayout
            component={BuscadorGuidView}
            exact
            layout={MainLayout}
            path={SCRNS.SCRN_BUSCADOR_UUID.path}
            title={SCRNS.SCRN_BUSCADOR_UUID.title}
            condition={logged}
            conditionPathRedirect={defaultPath}
            queryOrigin
         />
         <RouteWithLayout
            component={AbonosPasarelaView}
            exact
            layout={MainLayout}
            path={SCRNS.SCRN_ABONOS_PASARELA.path}
            title={SCRNS.SCRN_ABONOS_PASARELA.title}
            condition={logged}
            conditionPathRedirect={defaultPath}
            queryOrigin
         />
         <RouteWithLayout
            component={ReporteConciliadorView}
            exact
            layout={MainLayout}
            path={SCRNS.SCRN_REPORTE_CONCILIADOR.path}
            title={SCRNS.SCRN_REPORTE_CONCILIADOR.title}
            condition={logged}
            conditionPathRedirect={defaultPath}
            queryOrigin
         />
         <RouteWithLayout
            component={DashboradView}
            exact
            layout={MainLayout}
            path={SCRNS.SCRN_DASHBOARD.path}
            title={SCRNS.SCRN_DASHBOARD.title}
            condition={logged}
            conditionPathRedirect={defaultPath}
            queryOrigin
         />
         <RouteWithLayout
            component={RedirectLoginView}
            exact
            layout={MinimalLayout}
            path={SCRNS.SCRN_LOG_IN.path}
            title={SCRNS.SCRN_LOG_IN.title}
            condition={!logged}
         />
         <RouteWithLayout
            component={CallbackView}
            exact
            layout={MinimalLayout}
            path={SCRNS.SCRN_CALLBACK.path}
            title={SCRNS.SCRN_CALLBACK.title}
         />
         <RouteWithLayout
            component={NotFoundView}
            exact
            layout={logged ? MainLayout : MinimalLayout}
            path={SCRNS.SCRN_NOT_FOUND.path}
            title={SCRNS.SCRN_NOT_FOUND.title}
         />
         <RouteWithLayout
            component={DSLogin}
            exact
            layout={LoginLayout}
            path={SCRNS.SCRN_DS_LOG_IN.path}
            title={SCRNS.SCRN_DS_LOG_IN.title}
         />
         <RouteWithLayout
            component={DSSignUp}
            exact
            layout={LoginLayout}
            path={SCRNS.SCRN_DS_SIGN_UP.path}
            title={SCRNS.SCRN_DS_SIGN_UP.title}
         />
         <Redirect to={SCRNS.SCRN_NOT_FOUND.path} />
      </Switch>
   );
};

export default Routes;
